import {
  UserManager,
  WebStorageStateStore,
} from 'oidc-client';
import config from '@/config';

export default class AuthService {
  constructor() {
    const STS_DOMAIN = config.IDENTITY.AUTHORITY;
    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: STS_DOMAIN,
      client_id: 'cat4mro',
      redirect_uri: config.IDENTITY.REDIRECT_URI,
      automaticSilentRenew: true,
      silent_redirect_uri: config.IDENTITY.SILENT_REDIRECT_URI,
      accessTokenExpiringNotificationTime: 60,
      response_type: 'code',
      scope: 'openid profile roles email cat4mro-api-v1 identityadmin_api',
      post_logout_redirect_uri: config.IDENTITY.POST_LOGOUT_REDIRECT_URI,
      filterProtocolClaims: true,
    };
    this.userManager = new UserManager(settings);
  }

  /* eslint-disable */
  updateCurrentUser(userInfo) {
    if (userInfo) {
      window.localStorage.setItem('auth:token', userInfo.access_token);
    } else {
      window.localStorage.removeItem('auth:token');
    }

    return userInfo;
  }

  update() {
    return this.userManager.signinSilent().then((userInfo) => {
      return this.updateCurrentUser(userInfo);
    });
  }

  getUser() {
    return this.userManager.getUser().then((userInfo) => {
      return this.updateCurrentUser(userInfo);
    });
  }

  login() {
    return this.userManager.signinRedirect();
  }

  logout() {
    return this.userManager.signoutRedirect();
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthService.js